// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.2-next',
  revision: '8123fdaf',
  branch: 'next',
  date: 'Thu, 09 Apr 2026 12:57:16 GMT'
};